module.exports = __webpack_public_path__ + "static/media/icon-piece5-9.5547459d.png";